import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { AdsGETApi, AdsGETApiAuth, AdsPOSTApi, ExamBlockPlaceHolder, NodePOSTApiAuth } from '../../../Constant/api';
import { slugs } from '../../../Constant/slugs';
import { logout } from '../../../redux/action';
import NotFound from '../../NotFound';
import store from '../../../redux/store';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const slug = {
  "ubt": "UBT",
  "cbt-chemical": "CBT CHEMICAL",
  "cbt-electronics-electricity": "CBT ELECTRONIC ELECTRCITY",
  "cbt-food-related": "CBT FOOD RELATED",
  "cbt-mechinery-molding": "CBT MACHINERY,MOLDING",
  "cbt-metal": "CBT METAL",
  "cbt-pulp-paper-wood": "CBT PULP PAPER WOOD",
  "cbt-rubber": "CBT RUBBER",
  "cbt-textile-sewing": "CBT TEXTILE SEWING"
}
export default function StartCourse(props) {
  // const { ChapterData } = props;
  const dispatch = useDispatch()
  const history = useHistory();

  const LoginState = useSelector((state) => state.LoginState);
  const [ChapterData, setChapterData] = React.useState([])
  const [classDetails, setClassDetails] = React.useState({})
  const [choose, setChoose] = React.useState(0)
  const [NotFoundData, setNotFound] = React.useState(false)
  const [ExamFetch, setExamFetch] = React.useState(false);
  const [PreviewUrl, setPreviewUrl] = React.useState("")
  const [ExamData, setAllExamList] = React.useState({});
  const [PreviewPressed, setPreviewPressed] = React.useState(false)
  const [Reload, setReload] = React.useState(false)
  const [CourseContent, setCourseContent] = React.useState([])
  const [CourseContentCache, setCourseContentCache] = React.useState([])
  const [CourseGroupChoosen, setCourseGroupChoosen] = React.useState("All")
  const [CourseGroup, setCourseGroup] = React.useState()

  const fetchExam = (slug) => {
    setExamFetch(false)
    setReload(true)
    setNotFound(false)
    const id = store.getState().LoginState.userID

    NodePOSTApiAuth({ userID: id, slug: slug, role: LoginState.userRole }, "course-details")
      .then(res => {
        console.log(res.data.error)
        if (res.data.error == true) {
          setNotFound(true)
          console.log(41)
          setExamFetch(true)
        }
        else {
          setAllExamList(res.data.course_data_data[0])
          setCourseContent(JSON.parse(res.data.course_data_data[0].meta.course_content))
          setCourseContentCache(JSON.parse(res.data.course_data_data[0].meta.course_content))
          // setCourseContentCache([])
          setCourseGroup(JSON.parse(res.data.course_data_data[0].meta.course_group))
          setExamFetch(true)
        }
      })
      .finally(() => {
        setReload(false)
      })
      .catch(err => {
        console.log(err)
        console.log(err.response.data)
      })

  }
  const location = useLocation()
  useEffect(() => {
    fetchExam(location.pathname.slice(slugs.start_course.length + 1))

  }, [])

  return (
    <div style={{ margin: "3px" }}>
      {ExamFetch ?
        <>
          {NotFoundData ?
            <>
              <NotFound />
            </>
            :
            <>
              {/* <div className="row">
                <div className="col-1"></div>
                <div className="col-10 form-view mt-3">
                  <div className="row" style={{ margin: "10px" }}>
                    <h2>Classes</h2>
                  </div>
                </div>
              </div> */}

              <div className="row">
                <div className="col-1"></div>
                <div className="col-10 form-view mt-3">
                  <div style={{ margin: "10px 0" }}>
                    <h2>{ExamData.title.rendered}</h2>
                    <div className='row'>
                      <div className='col-sm-6'>

                        <LiveClass ExamData={ExamData} />
                      </div>
                      <div className='col-sm-6'>
                        <RecordedClass
                          CourseGroupChoosen={CourseGroupChoosen}
                          setCourseGroupChoosen={setCourseGroupChoosen}
                          setCourseContentCache={setCourseContentCache}
                          CourseGroup={CourseGroup}
                          CourseContentCache={CourseContentCache}
                          CourseContent={CourseContent}
                          history={history}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {PreviewPressed &&
                <div className="modal">
                  <div className="row">
                    <div className="col-1" />
                    <div class="modal-dialog" role="document" className="col-10">
                      <div class="modal-content">
                        <div class="modal-header">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                            onClick={() => { setPreviewPressed(false) }}
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <div style={{ minHeight: "78vh", overflowY: "scroll" }}>
                            <iframe
                              style={{ width: "100%", height: "70vh" }}
                              src={PreviewUrl
                                // PreviewObj.youtube_id == "" ? PreviewObj.video_link :
                                //   `https://www.youtube.com/embed/${PreviewObj.youtube_id}`
                              }>
                            </iframe>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </>
          }
        </>
        :
        <>
          <div className="modal" style={{ padding: "50vw" }}>
            <div className="dot-pulse"></div>
          </div>
        </>
      }
    </div >
  )
}


const LiveClass = ({ ExamData }) => {
  const [LiveClassListShow, setLiveClassListShow] = React.useState(false)
  var LiveClassList = ExamData.meta.live_group.length !== 0 ? Object.values(JSON.parse(ExamData.meta.live_group)) : []
  // var LiveClassList = []
  return (
    <div style={{
      // display: "flex" 
    }}>
      {/* {ExamData.meta.live_group} */}
      <div style={{ margin: "10px", padding: "10px" }}>
        <div onClick={() => {
          // setLiveClassListShow(!LiveClassListShow)
        }}>
          <a className="Link" href={ExamData.meta.class_link} target="_blank">
            <div style={{ padding: "5px 15px", textAlign: "center", borderRadius: "10px" }}>
              <img src="https://api.akbeducation.com/wp-content/uploads/2025/11/live.png"
                style={{ width: "80%", objectFit: "contain", borderRadius: "10px" }}
              /><br />
            </div>
          </a>
        </div>
      </div>
      {LiveClassListShow &&
        <div style={{ margin: "10px", padding: "10px" }}>
          {LiveClassList.map((item, index) => (
            <a key={index} className="Link" href={ExamData.meta.class_link} target="_blank">
              <div className='sign-in-button-2'>
                {item}
              </div>
            </a>
          ))}
        </div>
      }
    </div>
  )
}



const RecordedClass = ({
  CourseGroupChoosen, setCourseGroupChoosen, setCourseContentCache,
  CourseGroup, CourseContentCache, CourseContent, history
}) => {
  const [CourseGroupShow, setCourseGroupShow] = React.useState(false)
  const [CourseShow, setCourseShow] = React.useState(false)

  return (
    <div>
      <div style={{ margin: "10px 0", padding: "10px 0" }}>
        <div onClick={() => {
          setCourseGroupShow(!CourseGroupShow)
          if (CourseShow)
            setCourseShow(!CourseShow)
        }}>
          {/* <a className="Link" href={ExamData.meta.class_link} target="_blank"> */}
          <div style={{ padding: "5px 15px", textAlign: "center", borderRadius: "10px" }}>
            <img src="https://api.akbeducation.com/wp-content/uploads/2025/11/record.png"
              style={{ width: "80%", objectFit: "contain", borderRadius: "10px" }}
            /><br />
          </div>
          {/* </a> */}
        </div>
      </div>
      {CourseGroupShow &&
        <div style={{ margin: "20px" }}>
          <div>
            Courses:
          </div>
          <br />

          <span style={{
            cursor: "pointer",
            padding: "10px 25px", border: "1px solid black", borderRadius: "10px", margin: "10px",
            backgroundColor: CourseGroupChoosen == "All" ? "#f3f3f3" : "#fff"
          }}
            onClick={() => {
              setCourseShow(true)
              setCourseGroupChoosen("All")
              setCourseContentCache(Object.values(CourseContent))
            }}
          >
            All
          </span>
          <div style={{ display: "inline" }}>
            {Object.values(CourseGroup).map((item, index) => (
              <div key={index}
                style={{
                  display: "inline-block",
                  cursor: "pointer",
                  padding: "10px 25px", border: "1px solid black", borderRadius: "10px", margin: "3px",
                  backgroundColor: CourseGroupChoosen == item ? "#f3f3f3" : "#fff"
                }}
                onClick={() => {
                  setCourseShow(true)
                  setCourseGroupChoosen(item)
                  const spcFiltered = Object.fromEntries(
                    Object.entries(CourseContent).filter(([_, item2]) => item2.chapter_type === item)
                  );
                  setCourseContentCache(spcFiltered)
                }}
              >
                {item}
              </div>
            ))}
          </div>
        </div>
      }
      {CourseShow &&
        <div className="row" style={{ marginLeft: "10px" }}>
          {Object.values(CourseContentCache).map((item2, index2) => (
            <div key={index2} className="col-sm-6 col-12">
              <div className="shadow" style={{ cursor: "pointer", backgroundColor: "#fff", margin: "10px 0px 0 0 ", padding: "10px" }}
                onClick={() => {
                  var youtubeid = window.btoa(item2.youtube_id)
                  history.push(`/start-video/${youtubeid}`)
                }}
              >
                <h4>{item2.chapter_number}. {item2.title}</h4>
                <div>{item2.description}</div>
                <div style={{ padding: 10, textAlign: "center" }}>
                  <span style={{ border: "1px solid black", borderRadius: 5, padding: "5px 15px" }}> View</span>
                </div>
                <div style={{ marginLeft: "40px", fontSize: "12px" }}>
                </div>
              </div>
            </div>
          ))}
        </div>
      }
    </div>
  )

}